import { useLingui } from '@lingui/react/macro';

import { MobileEntityFilter } from '@/components/SharedFilters/EntityFilter/MobileEntityFilter';
import IconStoreRepair from '@/icons/StoreRepair.svg';

import { useFilters } from '../FiltersState';

export const FiltersWorkshop = () => {
  const { t } = useLingui();

  const {
    workshops: { workshops, setWorkshops },
  } = useFilters();

  return (
    <MobileEntityFilter
      filterId="workshop"
      selectedEntities={workshops}
      setSelectedEntities={setWorkshops}
      traits={['workshop']}
      label={t({ id: 'requests.filters.workshop.label', message: 'Workshop' })}
      searchPlaceholder={t({
        id: 'requests.filters.workshop.search.label',
        message: 'Search workshops',
      })}
      icon={<IconStoreRepair />}
    />
  );
};
